import React from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
} from "@headlessui/react";

const PopUpModal = ({ open = false, handleClose = () => {}, children }) => {
  const safeHandleClose = typeof handleClose === 'function' ? handleClose : () => {};

  return (
    <Dialog open={Boolean(open)} onClose={safeHandleClose} className="relative z-50">
      <DialogBackdrop
        className="fixed inset-0 bg-grey-900/50"
      />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <DialogPanel
          className="relative bg-white rounded-2xl shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto"
        >
          {children}
        </DialogPanel>
      </div>
    </Dialog>
  );
};
export default PopUpModal;
